import { useSelector } from "react-redux";
import PlaceholderImage from "../../products/PlaceholderImage";
import livingRoomTopView from "../../../assets/smarthome/living_room_top_view.jpg";
import installerWithTruck from "../../../assets/smarthome/installer_and_truck.jpg";
import appIpadIphone from "../../../assets/smarthome/app_ipad_and_iphone.png";

export default function AppSection(props) {
  const { textContent, language } = { ...props };

  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      {!isMobile ? (
        <div className="split-wrapper">
          <div className="split-grid">
            {/* Ligne 1 */}
            <div className="split-item textTopLeft">
              <h1 className="title-gradient">
                {textContent.appSection.title[language]}
              </h1>
              <h2> {textContent.appSection.subtitle[language]}</h2>
            </div>

            <div className="split-item image">
              <PlaceholderImage
                src={livingRoomTopView}
                crop={{ top: 0, right: 0, bottom: 0, left: 0 }}
              />
            </div>

            {/* Ligne 2 */}
            <div className="split-item image">
              <PlaceholderImage
                src={installerWithTruck}
                crop={{ top: 0, right: 0, bottom: 0, left: 0 }}
              />
            </div>

            <div className="split-item textBottomRight">
              <h1 className="title-gradient">
                {textContent.appSection.features.items.app.title[language]}
              </h1>
              <h2>
                {
                  textContent.appSection.features.items.app.description[
                    language
                  ]
                }
              </h2>
            </div>
          </div>
          <div className="split-center-box">
            <PlaceholderImage
              src={appIpadIphone}
              crop={{ top: 0, right: 0, bottom: 0, left: 0 }}
            />
          </div>
        </div>
      ) : (
        <div className="split-grid-mobile">
          {/* Bloc 1 */}
          <div className="mobile-top">
            <div className="split-item textTopLeft mobile">
              <h1 className="title-gradient">
                {textContent.appSection.title[language]}
              </h1>
              <h2> {textContent.appSection.subtitle[language]}</h2>
            </div>
            <div className="">
              <PlaceholderImage
                src={appIpadIphone}
                crop={{ top: 0, right: 0, bottom: 0, left: 0 }}
              />
            </div>
          </div>

          {/* Bloc 2 */}
          <div className="mobile-bottom">
            <div className="split-item textBottomRight mobile">
              <h1 className="title-gradient">
                {textContent.appSection.features.items.app.title[language]}
              </h1>
              <h2>
                {
                  textContent.appSection.features.items.app.description[
                    language
                  ]
                }
              </h2>
            </div>
            <div className="split-item image ">
              <PlaceholderImage
                src={installerWithTruck}
                crop={{ top: 0, right: 0, bottom: 0, left: 0 }}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
